const location = window.location

const apiPort = process.env.API_PORT
const apiVersion = process.env.API_VERSION
const apiPath = process.env.API_PATH 
const apiDomain = process.env.API_DOMAIN 
const stripeKey = process.env.STRIPE_KEY
const apiHost = process.env.API_HOST

const settings = {
    api: {
        port: urlPort(apiPort),
        version: apiVersion || 'v1',
        path: apiPath || 'api',
        domain: apiDomain|| 'maxelit-api',
        stripe_key: stripeKey,
        host: parentDomain(apiHost)
    }
}


export const GLOBAL_URL = `//${settings.api.domain}.${settings.api.host}${settings.api.port}/${settings.api.path}/${settings.api.version}`

export const API_KEY_STRIPE= settings.api.stripe_key
export const FIELD_REQUIRED = 'Campo requerido';
export const VALID_EMAIL = 'Ingrese un correo electrónico válido'
export const PASSWORD_NOT_MATCH = 'Las contraseñas no coinciden';
export const USED_EMAIL = 'Correo electrónico en uso'


function parentDomain (settingsDomain: string | undefined) {
  if (settingsDomain !== undefined) return settingsDomain
  const domains = location.hostname.split('.')
  return domains.length > 2
    ? domains.slice(1).join('.')
    : location.hostname
}

function urlPort(settingsPort: string | undefined) {
    switch(settingsPort) {
        case '80':
        case '443':
        case undefined:
            return ''
        default: return `:${settingsPort}`
    }
}
